var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "14px",
    viewBox: "0 0 4 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.75,6.5 C10.7125,6.5 11.5,5.7125 11.5,4.75 C11.5,3.7875 10.7125,3 9.75,3 C8.7875,3 8,3.7875 8,4.75 C8,5.7125 8.7875,6.5 9.75,6.5 L9.75,6.5 Z M9.75,8.25 C8.7875,8.25 8,9.0375 8,10 C8,10.9625 8.7875,11.75 9.75,11.75 C10.7125,11.75 11.5,10.9625 11.5,10 C11.5,9.0375 10.7125,8.25 9.75,8.25 L9.75,8.25 Z M9.75,13.5 C8.7875,13.5 8,14.2875 8,15.25 C8,16.2125 8.7875,17 9.75,17 C10.7125,17 11.5,16.2125 11.5,15.25 C11.5,14.2875 10.7125,13.5 9.75,13.5 L9.75,13.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Unit/More_Vert",
    transform: "translate(-8.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#606a7f",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.83b3fe4f261e9c533ce8ee417f76c515.svg";
export { ForwardRef as ReactComponent };